import * as actionTypes from '../actions/actionTypes';

import { updateObject }  from '../utility';

const initialstate = {
    userView: ''
}

const reducer = (state = initialstate, action) => {
    switch(action.type) {
        case actionTypes.SET_USER_VIEW:
            let userView = '';
            if (action.val === state.userView) {
                userView = '';
            } else { userView = action.val }
            return updateObject(state, { userView: userView })
        default:
            return state;
    }
}

export default reducer; 


// WEBPACK FOOTER //
// ./src/store/reducers/user.js